import { ProductType } from '../../constants';
import type { Product, VariationProduct } from '../../model';

/** Label the SKU that the cart card adds, rather than the parent product's default pack. */
export function getCartProductPackLabel(product: Product | VariationProduct, purchaseSku?: string): string | null {
  const sku = purchaseSku?.trim();
  if (!sku) {
    return null;
  }

  const selected = (() => {
    if (product.type === ProductType.Variable) {
      return product.variations?.find((variation) => variation.sku.trim() === sku);
    }
    return product.sku.trim() === sku ? product : undefined;
  })();
  const match = selected?.pack?.trim().match(/^(\d+)\s*packs?$/i);
  if (!match) {
    return null;
  }

  const count = Number(match[1]);
  return Number.isSafeInteger(count) && count > 1 ? `${count} Packs` : null;
}
